import React, { Component, useEffect, useState } from "react";
import ComponentFAQMobile from "./ComponentFAQMobile";
import ComponentFAQWeb from "./ComponentFAQWeb";
import { BrowserView, MobileView } from "react-device-detect";
import useAnalyticsEventTracker from "../../core/service/useAnalyticsEventTracker";
import ReactGA from "react-ga4";
const ComponentFAQ = () => {
  const gaEventTracker = useAnalyticsEventTracker("FAQ");
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
      title: "FAQ",
    });
  }, []);
  return (
    <>
      <BrowserView>
        <ComponentFAQWeb></ComponentFAQWeb>
      </BrowserView>
      <MobileView>
        <ComponentFAQMobile></ComponentFAQMobile>
      </MobileView>
    </>
  );
};

export default ComponentFAQ;
